<template>
    <div>
        <modal :show="show">
            <div class="modal-header">
                <h5 class="modal-title">{{type}} Account</h5>
                <a href="javascript:void(0)" v-on:click="close()" class="close">
                    <em class="icon ni ni-cross"></em>
                </a>
            </div>
            <div class="modal-body">

                <form>

                    <div class="row">
                        <div class="form-group col-md-6" v-if="type=='Add'">
                            <label>Account Type</label>
                            <select v-model="newTypeId" class="form-control" v-if="show">
                                <option value="">Select account Type</option>
                                <option v-for="accountType in accounts.accountTypes" v-bind:key="accountType.id" :value="accountType.id">{{ accountType.name }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6 text-left" v-if="type=='Add'">
                            <label>Cost Center</label>
                            <span v-if="newTypeId!== undefined">
                                <select v-model="account.costCenterId" class="form-control" v-if="show">
                                    <option value="-1">Select cost Center</option>
                                    <option v-for="costCenter in costCenters" v-bind:key="costCenter.id" :value="costCenter.id">{{ costCenter.name }}</option>
                                </select>
                            </span>
                        </div>
                        <div class="form-group text-left" v-bind:class="{'has-danger': $v.account.code.$error, 'col-md-4' :type== 'Add' , 'col-md-12':type=='Edit' }">
                            <label style="margin-right:90px">Code</label>
                            <input v-model.trim="$v.account.code.$model" class="form-control" />
                            <span v-if="!$v.account.code.required && $v.account.code.$error" class="error validation-error field-validation-valid">Code is required.</span>
                            <span v-if="!$v.account.code.isExist && $v.account.code.$error" class="error validation-error field-validation-valid">Code is already exist</span>

                        </div>

                        <div class="form-group text-left" v-bind:class="{'has-danger': $v.account.name.$error, 'col-md-8' :type== 'Add' , 'col-md-12':type=='Edit' }">
                            <label>Name</label>
                            <input v-model.trim="$v.account.name.$model" class="form-control" />
                            <span v-if="!$v.account.name.required && $v.account.name.$error" class="error validation-error field-validation-valid">Name is required.</span>

                        </div>
                        <!--<div class="form-group col-md-12 text-left" >
                            <label >Opening Balance</label>
                            <input v-model="account.openingBalance"  v-on:input="GetOpeningBalance(account.openingBalance)" class="form-control" type="number" />
                        </div>-->
                        <!--<div class="form-group col-md-12">
                            <label>Running Balance</label>
                            <input v-model="account.runingBalance" disabled class="form-control" type="number" />
                        </div>-->

                        <div class="form-group col-md-12 text-left">
                            <label>Description</label>
                            <input v-model="account.description" class="form-control" />
                        </div>

                        <div class="form-group col-md-12 text-left">

                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="account.isActive">
                                <label class="custom-control-label" for="customSwitch1">Active</label>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer bg-light">
                <button v-if="type==='Edit'" @click="$event.target.disabled = true" type="button" class="btn btn-primary btn-round" v-on:click="updateAccount(account)" :disabled="$v.account.$invalid">Update</button>
                <button v-else @click="$event.target.disabled = true" type="button" class="btn btn-primary btn-round" v-on:click="addAccount(account)" :disabled="$v.account.$invalid">Save</button>
                <button type="button" class="btn btn-danger btn-round" v-on:click="close()">Cancel</button>
            </div>
        </modal>
    </div>
</template>
<script>
    import { required } from "vuelidate/lib/validators";
    import axios from 'axios';
    export default {
        props: ['account', 'account-type-id', 'type', 'show'],
        data: function () {
            return {
                accounts: '',
                newTypeId: '',
                oldCode: '',
                isDisable: false,
                costCenters: []
            }
        },
        validations: {
            account: {
                code: {
                    required: required,
                    isExist: function (value) {
                        if (value === '' || value === this.oldCode) return true;

                        return new Promise(function (resolve, reject) {

                            resolve(
                                axios.get('/Accounting/IsAccountExist?code=' + value)
                                    .then(function (response) {
                                        if (response.data.value) {
                                            console.log("isExist");
                                            return false;
                                        } else {
                                            console.log("Not isExist");
                                            return true;

                                        }
                                    },
                                        function () {
                                            console.log(" not isExist");
                                            return true;

                                        })
                            );

                            reject(console.log("ddd"));

                        });
                    }
                },
                name: {
                    required: required
                }
            }
        },
        methods: {
            GetOpeningBalance: function () {
                this.account.runingBalance = this.account.openingBalance;
            },
            updateAccount: function (account) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.post('/Accounting/UpdateAccount', account, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.value === true) {
                            var data = root.accounts.accountTypes.find(function (x) {
                                return x.id === root.accountTypeId;
                            }).costCenters.find(function (y) {
                                return y.id === root.account.costCenterId;
                            }).accounts
                                .find(function (z) { return z.id === response.data.id });
                            data.code = root.account.code;
                            data.name = root.account.name;
                            data.description = root.account.description;
                            data.isActive = root.account.isActive;
                            data.openingBalance = root.account.openingBalance;
                            data.runingBalance = root.account.runingBalance;

                            root.$swal({
                                title: 'Updated!',
                                text: 'Account has been Updated.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            });
                            root.$emit('close');
                        } else {
                            root.$emit('close');
                            this.$swal({
                                title: 'Error!',
                                text: 'Account does not Updated.',
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                        }
                    },
                        function (error) {
                            root.$emit('close');
                            root.$swal({
                                title: 'Error!',
                                text: error,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                        });
            },

            addAccount: function (account) {
                account.id = "00000000-0000-0000-0000-000000000000";
                var root = this;

                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                 //eslint-disable-line
                root.$https.post('/Accounting/AddAccount', account, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.value === true) {


                            root.accounts.accountTypes.find(function (x) {
                                return x.id === root.newTypeId;
                            }).costCenters.find(function (y) {
                                return y.id === root.account.costCenterId;
                            }).accounts.push({
                                costCenterId: root.account.costCenterId,
                                code: root.account.code,
                                description: root.account.description,
                                id: response.data.id,
                                isActive: root.account.isActive,
                                runingBalance: root.account.runingBalance,
                                openingBalance: root.account.openingBalance,

                                name: root.account.name
                            });

                            
                            root.$swal({
                                title: 'Add!',
                                text: 'Account has been add successfully.',
                                type: 'success',
                                icon: 'success',
                                confirmButtonClass: "btn btn-success",
                                buttonsStyling: false
                            });
                            root.$emit('close');

                        } else {

                            root.$swal({
                                title: 'Error!',
                                text: 'Account does not add.',
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });

                            root.$emit('close');
                        }
                    },
                        function (error) {
                            root.$emit('close');

                            root.$swal({
                                title: 'Error!',
                                text: error,
                                type: 'error',
                                icon: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                        });
            },

            close: function () {
                this.$emit('close');
            }
        },

        created: function () {

            //compatibilty with IE
            this.oldCode = this.account.code;
            this.newTypeId = this.accountTypeId;

        },
        mounted: function () {
            this.accounts = this.$store.state.accounts;
            if (this.account.openingBalance > 0) {
                this.isDisable = true;
            } else {
                this.isDisable = false;

            }


        },
        watch: {
            account: function (a) {
                //compatibilty with chrome
                this.oldCode = a.code;
            },
            newTypeId: function (newTypeId) {
                this.costCenters = this.accounts.accountTypes.find(function (x) { return x.id == newTypeId; }).costCenters;
            }
        }

    }
</script>